import DM from 'DM';
import Vue from 'vue';
import store from '~/store/index.js';
import MegaMenuComponent from '~/components/menu/mega-menu-component.vue';
import MegaMenuStore from '~/store/modules/mega-menu-store.js';

const ELEMENTS = document.querySelectorAll('.js-page-nav-async');

class MenuHydration {
    constructor(element) {
        this.vm = this.createComponent(element);
    }
    createComponent(element) {
        let name = element.getAttribute('data-name');
        let url = element.getAttribute('data-href');
        let cssClass = element.getAttribute('data-css-class');
        let menuType = element.getAttribute('data-menu-type');
        let isSpecial = element.getAttribute('data-is-special') === 'true';

        if(!store.hasModule('megaMenu')){
            store.registerModule('megaMenu', MegaMenuStore);
        }
        return new Vue({
            name: 'MegaMenu',
            render: h => h(MegaMenuComponent, { props: {
                    name: name,
                    url:url,
                    cssClass: cssClass,
                    isSpecial: isSpecial,
                    iconsSetVersion: DM.Config.IconsSetVersion,
                    forcePreview: DM.Config.forcePreview,
                    menuType: menuType
                }
            }),
            el: element,
            store
        });
    }
}

for (let index in ELEMENTS) {
    if (ELEMENTS[index].getAttribute !== undefined) {
        new MenuHydration(ELEMENTS[index]);
    }
}

